module.exports = __webpack_public_path__ + "img/terminal.830c02d2.svg";